<template>
<div>


<template v-if="thenonconformities.length && flowsupplier.status=='finished'">
<h2 class="text-purple-500 mt-4 mb-6">{{$store.state.languages.lang_phrases.uygunsuzluklar_var}}</h2>
<ContentTable :data="thenonconformities" :columns="columns" routename="SupplierBrandFlowNonconformity"   identifier_row="id" identifier_row_name="nonconformity_id"></ContentTable>
<br/>
</template>


<template v-if="flowsupplier.status !=='finished' && flowsupplier.status !=='under_review'">
  


<CollapsePanel 
:title="$store.state.languages.lang_phrases.lutfen_denetlemeden_muafiyet_icin_varsa_asagidaki_sertifikalarinizi_bildirin"
:success_title="$store.state.languages.lang_phrases.muafiyet_belgeleri_incelendi"
:completed="is_exempted_from_audit"
:missing_documents="missing_exempt_docs"
v-if="exemptioncertificates.length"
>  
<template v-slot:content>
<SupplierCertificateUploader 
v-for="exemptioncertificate in exemptioncertificates" 
:key="exemptioncertificate.id"
:certificatetype="exemptioncertificate.certificatetype"
:thecertificate="exemptioncertificate"
@fileReadyToUpload="uploadFile"
>
</SupplierCertificateUploader>

</template>
</CollapsePanel>


<!--
<br/>
<CollapsePanel 
title="Lütfen denetlemede ihtiyaç duyulacak sertifikalarınızı yükleyin"
success_title="Gerekli Belgeler incelendi"
:completed="is_audit_documents_uploaded"
:missing_documents="missing_reqt_docs"
v-if="requiredcertificates.length"
>  
<template v-slot:content>
<SupplierCertificateUploader 
v-for="requiredcertificate in requiredcertificates" 
:key="requiredcertificate.id"
:certificatetype="requiredcertificate.certificatetype"
:thecertificate="requiredcertificate"
@fileReadyToUpload="uploadFile"
>
</SupplierCertificateUploader>

</template>
</CollapsePanel>
-->

</template> 



</div>
</template>

<script>
export default {

  name: 'SupplierBrandFlowSummaryForAudit',
  props:["flowsupplier","exemptioncertificates","requiredcertificates","nonconformities","nonconformity_types"],
  data () {
    return {
      thenonconformities:[],
      columns:[  
      {
        type:"text",
        field:"inputfield_name", 
        multilingual:true,
        header:"soru",      
        with_route:true,
        hide_on_mobile:false,
      }, 
      {
        type:"pill",
        field:"status", 
        header:"durum",       
        options:[
          {
            name:"pending",
            color:"#352f8d",
            text:"degerlendirmede",
          },
          {
            name:"rejected",
            color:"#dd4b39",
            text:"reddedildi",
          },
          {
            name:"approved",
            color:"#4dc247",
            text:"tamamlandi",
          },
          {
            name:"open",
            color:"#ff6600",
            text:"beklemede",
          },
        ],
      },
      ]
    }
  },
  mounted()
  {
    if(this.nonconformity_types.length)
    {
      
      let obj = {
        type:"text",
        field:"nonconformity_type_name", 
        header:"uygunsuzluk_tipi", 
        multilingual:true,
      }     
      this.columns.push(obj) 

    }
    if(this.nonconformities.length)
    {
      for(let nonconformity of this.nonconformities)
      {
        nonconformity = this.prepareNonconformity(nonconformity) 
        this.thenonconformities.push(nonconformity)
      }
    }
  },
  computed:{
    missing_exempt_docs()
    {
      let count =  this.exemptioncertificates.length
      for(let exemptioncertificate of this.exemptioncertificates)
      {
        for(let element of exemptioncertificate.documents)
        {
          if(element.status == "accepted")
          {
            count--
          }
        }
      }
      return count
    },
    missing_reqt_docs()
    {
      let count =  this.requiredcertificates.length
      for(let exemptioncertificate of this.requiredcertificates)
      {
        for(let element of exemptioncertificate.documents)
        {
          if(element.status == "accepted")
          {
            count--
          }
        }
      }
      return count
    },
    is_exempted_from_audit()
    {
      let is_exempted_from_audit = 0
      for (let i = 0; i < this.exemptioncertificates.length; i++)
      {
        let is_document_exempted = 0
        for (let ii = 0; ii < this.exemptioncertificates[i].documents.length; ii++)
        {
          if(this.exemptioncertificates[i].documents[ii].status=="accepted" )
          {
            is_document_exempted = 1  
            break          
          }
          else
          {
            is_document_exempted = 0 
          }
        }

        if(is_document_exempted)
        {
          is_exempted_from_audit = 1
        }
        else
        {
          is_exempted_from_audit = 0
          break
        }
      }
    

    return is_exempted_from_audit

    },

    is_audit_documents_uploaded()
    {
      let is_exempted_from_audit = 0
      for (let i = 0; i < this.requiredcertificates.length; i++)
      {
        let is_document_exempted = 0
        for (let ii = 0; ii < this.requiredcertificates[i].documents.length; ii++)
        {
          if(this.requiredcertificates[i].documents[ii].status=="accepted" )
          {
            is_document_exempted = 1  
            break          
          }
          else
          {
            is_document_exempted = 0 
          }
        }

        if(is_document_exempted)
        {
          is_exempted_from_audit = 1
        }
        else
        {
          is_exempted_from_audit = 0
          break
        }
      } 
    return is_exempted_from_audit
    },
  },
  methods:{
  	uploadFile(item)
  	{
  		this.$emit("fileReadyToUpload",item)
  	},
    prepareNonconformity(nonconformity)
    {
      console.log("prepareNonconformity")
      console.log(nonconformity)
      let obj = nonconformity.inputfield
      obj.completion = true
      obj.show_evidence_btn = false
      obj.show_info_textarea = false
      obj.read_only_state = true
      
      nonconformity.inputfield = obj
      if(nonconformity.inputfield.translations.length)
      {
        nonconformity.inputfield_name = nonconformity.inputfield.translations
        this.columns[0].multilingual = true
      }
      else
      {
        nonconformity.inputfield_name = nonconformity.inputfield.name
        this.columns[0].multilingual = false
      }
      
      if(nonconformity.lastclosurerequest)
      {
        if(nonconformity.lastclosurerequest.status=="pending")
        {
          nonconformity.status = "pending"
        }
        if(nonconformity.lastclosurerequest.status=="rejected")
        {
          nonconformity.status = "rejected"
        }

        if(nonconformity.lastclosurerequest.status=="approved")
        {
          nonconformity.status = "approved"
        }
      }
      let type = this.nonconformity_types.find((item)=>{return item.id == nonconformity.nonconformitytype_id})
      
      if(type)
      {
        if(type.translations.length)
        {
          nonconformity.nonconformity_type_name = type.translations
          this.columns[2].multilingual = true
        }
        else
        {
          nonconformity.nonconformity_type_name = type.name
          this.columns[2].multilingual = false
        }
        
      }
      else
      {
        nonconformity.nonconformity_type_name = "dfdfdf"
      }

      return nonconformity
    },
    nonconformityDataUpdated(data)
    {
      let ind = this.thenonconformities.findIndex((item)=>{return item.id == data.id})      
      this.thenonconformities[ind] = this.prepareNonconformity(data)
    }
  }
}
</script>

<style lang="css" scoped>
</style>